import { Users } from "lucide-react";

// NO-651: an admin adds RDs from the RD registry, so this card names that one
// way in and offers no action of its own.
export function EmptyStateCard({ userName }: { userName: string }) {
  const firstName = userName.split(" ")[0] || userName;

  return (
    <div className="h-full flex items-center justify-center p-20">
      <div className="max-w-[520px] text-center flex flex-col items-center gap-4">
        <div className="h-[88px] w-[88px] rounded-full bg-ai-soft flex items-center justify-center">
          <Users className="h-10 w-10 text-ai" />
        </div>

        <div className="flex flex-col items-center gap-3">
          <h2 className="text-[32px] font-semibold font-sans text-foreground tracking-tight leading-10">
            Welcome to AlwaysAI, {firstName}
          </h2>
          <p className="text-base text-muted-foreground leading-relaxed max-w-[440px]">
            You don&apos;t have any RDs added yet. An admin adds RDs from the RD
            registry.
          </p>
        </div>
      </div>
    </div>
  );
}
